// Modal.js
import React from 'react';
import './Modal.scss'; // Ensure you have your CSS styles here

const Modal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.8)"
      }}>
        <span className="close" onClick={onClose}>&times;</span>
        <h2></h2>
        <p style={{
          marginTop: "10px",
          width: "auto",
          maxWidth: "100%",
          fontFamily: "Montserrat, Poppins, sans-serif",
          textTransform: "uppercase",
          letterSpacing: "2.5px",
          fontSize: "1rem",
          height: "40px",
          border: "",
          borderRadius: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>{message}</p>
        <button className="confirm-btn" onClick={onClose} style={{
          marginTop: "40px"
        }}><p style={{
          width: "auto",
          maxWidth: "100%",
          fontFamily: "Norwester, Poppins, sans-serif",
          textTransform: "uppercase",
          letterSpacing: "2.5px",
          fontSize: "1rem",
          height: "15px",
          background: "#009ED0",
          border: "none",
          borderRadius: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>OK</p></button>
      </div>
    </div>
  );
};

export default Modal;